export default [
    {path: '/jobs/:id/tabs/:tab', screen: 'job/DisplayJob', secured: true, role: ['admin']},
    {path: '/jobs/:id', screen: 'job/DisplayJob', secured: true, role: ['admin']},
    {path: '/jobs', screen: 'job/ListJobs', secured: true, role: ['admin']},
    {path: '/job/new', screen: 'job/CreateJob', secured: true, role: ['admin']},
]